import { useState } from "react";
import { useParams } from "react-router-dom";

function ShipmentImage({ token, index }) {
  const [unavailable, setUnavailable] = useState(false);

  return (
    <section style={{ border: "1px solid #ddd", borderRadius: 12, padding: 16 }}>
      <h2>Shipment image {index + 1}</h2>
      {unavailable ? (
        <p role="status">Image expired or unavailable. Please request a new link.</p>
      ) : (
        <img
          src={`https://admin.uklbutter.com/shipment-image/${token}.png`}
          alt={`Shipment ${index + 1}`}
          referrerPolicy="no-referrer"
          style={{ width: "100%", height: "auto" }}
          onError={() => setUnavailable(true)}
        />
      )}
    </section>
  );
}

export default function ShipmentView() {
  const { tokens = "" } = useParams();
  const images = [...new Set(tokens.split(",").filter(
    token => /^[A-Za-z0-9_-]{43}$/.test(token)
  ))].slice(0, 8);

  return (
    <main className="container" style={{ paddingTop: 32, paddingBottom: 32 }}>
      <h1>UKL Butter — Your shipment images</h1>
      <p>View the shipment photos and tracking receipt shared with you.</p>
      {images.length === 0 ? (
        <p role="status">No valid shipment images found. Please request a new link.</p>
      ) : (
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(min(260px, 100%), 1fr))",
          gap: 20
        }}>
          {images.map((token, index) => (
            <ShipmentImage key={token} token={token} index={index} />
          ))}
        </div>
      )}
    </main>
  );
}
